import React from 'react';

import { StatusPicker } from './status'
import Select from 'react-select'
import ControlledInput from './controlledInput';
import SearchBar from './searchBar'
import working from './img/working.png'
import RightButtons from './rightButtons';
import api from './apiConnector'

const typeToSponsor = {'motoecole':'la moto-école','concessionnaire':'le concessionnaire'}

class Timeline extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sendingEmail:false,
            sponsor:false,
            contact:false,
            affiliateError:false
        }
        this.dateFormatter = new Intl.DateTimeFormat('fr',{ dateStyle: 'short', timeStyle: 'short' })
    }

    componentDidMount() {

        const me = this
        if ( this.props.devis.affiliate ) {
            api.post(
                {action:'get_sponsor_contact',
                login:this.props.devis.affiliate},
                (res)=>{
                    me.setState({contact:res.contact,sponsor:res.sponsor})
                },
                () => {
                    me.setState({affiliateError:true})
                }
            )
        }
    }

    setStatusProcess(option) {
        this.props.container.setStatusProcess(option.value)
    }

    sendDevisEmail() {
        this.setState({sendingEmail:true})
        this.props.container.sendDevisEmail(this.gotEmail.bind(this))
    }


    gotEmail() {
        this.setState({sendingEmail:false})
    }

    renderEvent(event,key) {
        return <div key={key} className='event'>
            {this.dateFormatter.format(1000 * event.date)} - {event.user} - {event.status}
        </div>
    }

    renderAffiliate() {
        const {contact,sponsor,affiliateError} = this.state
        if ( affiliateError ) return <div className="timeline_affilie">Apporteur affilié {this.props.devis.affiliate} inconnu (supprimé ?)</div>
        return <div className="timeline_affilie">Apporteur affilié : {contact.prenom} {contact.nom} de {typeToSponsor[sponsor.type]} {sponsor.nom} à {sponsor.ville}</div>
    }

    onSelectBranch(branch) {
        api.post(
            {action:'select_branch',
            sessionId:this.props.devis.typedId(),
            branch:branch},
            ()=>{}
        )
    }

    render() {
        const {devis} = this.props
        const {params,tb} = devis
        const BranchButton = ({branch}) => <div className={'status_picker_item'+( ( branch==tb )?' status_picker_selected':'' )}
            onClick={()=>this.onSelectBranch(branch)}>{branch}</div>
        const list = devis.history.filter( 
            event => ! event.status.match(/^Email|^SMS/)
        ).map( this.renderEvent.bind(this) )

        const listMails = devis.history.filter( 
            event => event.status.match(/^Email|^SMS/)
        ).map( this.renderEvent.bind(this) )

        const status_process = devis.status_process
        const defaultValue = SearchBar.optionsStatusProcessReal.find(option=>{return option.value==status_process})
        const emailButtonClass = 'button'+(this.state.sendingEmail?' disabled':'')
        const emailButton = ( params.email&&devis.synchronized ) ? 
                <a className={emailButtonClass} onClick={this.sendDevisEmail.bind(this)}>Envoyer le devis à <br/>{params.email}</a>
        : ''
        return <div className="timeline_container">
            {( this.state.contact||this.state.affiliateError )? this.renderAffiliate() : ''}
            <StatusPicker container={this.props.container} status={devis.status}/>
            <div className="columns">
                <div className="details_section">
                    <BranchButton branch="xena"/><BranchButton branch="axa"/><BranchButton branch="fma"/>
                    <Select options={SearchBar.optionsStatusProcessReal} value={defaultValue} onChange={this.setStatusProcess.bind(this)}/>
                    Ajouter un commentaire :&nbsp;
                    <ControlledInput type="text" property="editComment" container={this.props.container} onSubmit={this.props.container.onComment.bind(this.props.container)}/>
                    <img src="img/send-plane-fill.png" className="button" onClick={this.props.container.onComment.bind(this.props.container)}/>
                    <div className="timeline">
                    {list}
                    </div>
                    <p>Échanges email et SMS</p>
                    <div className="timeline">
                    {listMails}
                    </div>
                </div>
                <RightButtons {...this.props}/>
            </div>

        </div>
    }
}

export default Timeline;
